import React, {useState} from 'react';
import {Table, Form, Input} from 'antd';

export const EditableCell = ({
                                 editing,
                                 dataIndex,
                                 title,
                                 inputType,
                                 record,
                                 index,
                                 children,
                                 ...restProps
                             }) => {
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `This field is required`,
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};


export const ConnectionEditTable = ({originData, onUpdateConnectionData}) => {
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');

    const isEditing = record => record.key === editingKey;

    const edit = record => {
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey('');
    };

    const save = async (record) => {
        try {
            const row = await form.validateFields();
            const value = row.value.trim().split(' ').join('_');
            const newData = [...originData];
            newData.splice(0, 1, {...newData[0], value});
            onUpdateConnectionData(record.value, value);
            setEditingKey('');
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    const columns = [
        {
            title: 'Property',
            dataIndex: 'property',
            width: '35%',
            editable: false,
        },
        {
            title: 'Value',
            dataIndex: 'value',
            width: '35%',
            editable: true,
        },
        {
            title: '',
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
            <a
                href="#"
                onClick={() => save(record)}
                style={{marginRight: 8}}
            >
              Save
            </a>
              <a href="#"
                 style={{marginRight: 8}}
                 onClick={cancel}>Cancel</a>
          </span>
                ) : (
                    <a onClick={() => edit(record)}>
                        Edit
                    </a>
                );
            },
        },
    ];
    const mergedColumns = columns.map(col => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: record => ({
                record,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    return (
        <Form form={form} component={false}>
            <Table
                components={{body: {cell: EditableCell}}}
                bordered
                dataSource={originData}
                columns={mergedColumns}
                rowClassName="editable-row"
                size="small"
                pagination={{
                    onChange: cancel,
                }}
            />
        </Form>
    );
};
